import { __decorate } from "tslib";
import { AsnType, AsnTypeTypes } from "@peculiar/asn1-schema";
import { Name } from "@peculiar/asn1-x509";
import { DomainName } from "./domain_name";
import { id_ntQWAC } from "./oids";
export const id_DomainNameLegalRepresentative = `${id_ntQWAC}.2`;
let DomainNameLegalRepresentative = class DomainNameLegalRepresentative extends DomainName {
    constructor(items) {
        super(items);
        Object.setPrototypeOf(this, Name.prototype);
    }
};
DomainNameLegalRepresentative = __decorate([
    AsnType({ type: AsnTypeTypes.Sequence })
], DomainNameLegalRepresentative);
export { DomainNameLegalRepresentative };
